<template>
  <form class="col-12 b-form b-dialog__form">
    <server-error class="mb-4" :error="error" />
    <CreateAssetWidget @closeDialog="closeDialog" @saveAsset="onSaveAsset($event)"></CreateAssetWidget>
  </form>
</template>

<script>
	import CreateAssetWidget from "../../../../widgets/CreateAssetWidget";

	export default {
		components: {
			CreateAssetWidget,
    },
		data() {
			return {
				error: null,
			}
		},
    methods: {
			async onSaveAsset(data) {
				try {
					this.error = null;
          if (!data.businessUnitId) {
            if (data.businessUnitName || data.businessUnitExternalId) {
              const newBusinessUnit = await this.$store.dispatch('createBusinessUnit', [data.businessUnitName, data.businessUnitExternalId]);
              data.businessUnitId = newBusinessUnit.idInDB;
            }
          }
					const newAsset = await this.$store.dispatch('createAsset', Object.assign({}, data));
					this.$emit('createAsset', newAsset);
					this.closeDialog();
				} catch (e) {
					this.error = e;
				}
      },
			closeDialog() {
				this.$emit('closeDialog');
      }
    }
	}
</script>
